import api from '../../api/api'

// initial state
const state = {
	all: [],
  filtered: [],
  errors: {},
  scenario: null,
  status: {
    getAllScenarios: null,
    getScenario: null,
    getFilteredScenarios: null
  }
}

// getters
const getters = {}

// actions
const actions = {
  getScenario ({ commit, state }, id) {
    commit('setStatus', { getScenario: api.status.PENDING })
    return api.getScenario(id.replace(/\/scenario\//, '')).then((response) => {
      commit('setStatus', { getScenario: api.status.SUCCESS })
      commit('setScenario', response.data)
    }).catch((error) => {
      commit('setStatus', { getScenario: api.status.FAILURE })
    })
  },
  getAllScenarios ({ commit, state }, params) {
    commit('setStatus', { getAllScenarios: api.status.PENDING })
    return api.getAllScenarios(params).then((response) => {
      commit('setStatus', { getAllScenarios: api.status.SUCCESS })
      commit('setAllScenarios', response.data)
    }).catch((error) => {
      commit('setStatus', { getAllScenarios: api.status.FAILURE })
    })
  },
  getFilteredScenarios ({ commit, state }, params) {
    commit('setErrors', {})
    commit('setStatus', { getFilteredScenarios: api.status.PENDING })
    return api.getScenarios(params).then((response) => {
      commit('setStatus', { getFilteredScenarios: api.status.SUCCESS })
      commit('setFilteredScenarios', response.data)
    }).catch((error) => {
      commit('setErrors', error.response.data.errors)
      commit('setStatus', { getFilteredScenarios: api.status.FAILURE })
    })
  }
}

// mutations
const mutations = {
  setAllScenarios (state, scenarios) {
    state.all = scenarios
  },
  setScenario (state, scenario) {
    state.scenario = scenario
  },
  setFilteredScenarios (state, scenarios) {
    state.filtered = scenarios
  },
  setErrors (state, errors) {
    state.errors = errors
  },
  setStatus (state, status) {
    Object.assign(state.status, status)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
